import * as z from "zod";

import { PollingIntervalGroups } from "apollo/constants";

export const flags = {
  bananaMode: false,
  "fe-marketing-banners": [],
  "fe-global-callout": null,
  "frontend-polling-seconds": {},
  "enable-api-key-creation-for-non-root-admins-frontend": false,
  "use-new-topological-sort-in-runs-view": false,
  "number-of-deployments-widget-frontend": false,
  "approval-policy-evaluations-widget-frontend": false,
  "stack-list-tag-column": false,
  "vcs-improvements": false,
  "bitbucket-api-token-support": false,
  "worker-pool-drift-run-limit": false,
  "org-settings-for-space-admins": false,
  "strip-ansi-codes-from-logs": false,
  "non-root-admin-role-bindings": false,
  "azure-devops-project-scope": false,
  "spacelift-test-pilot-program-dashboard-widget": false,
  "disable-administrative-stacks": false,
  "flows-integration": false,
  "flows-aac-integration": false,
  "login-policy-space-access-v2": false,
  "github-link": false,
  "slack-link": false,
  "microsoft-teams-link": false,
  "opentofu-backend": false,
  "disable-infra-assistant-default-view": false,
  "vcs-provider-blob-storage": false,
  "vcs-provider-origin": false,
  "pylon-chat-visbility": false,
  "unmanaged-resources-ui": false,
  "run-observability-tab": false,
  "stack-pull-requests-list-redesign": false,
  "personal-api-keys": false,
  "pylon-verification-set-account-external-id": false,
  "pylon-verification-set-contact-external-id": false,
  "pylon-verification-overrides": {},
  "october-2026-pricing-changes": false,
};

export const selfHostedFlags = {
  "org-settings-for-space-admins": false,
  "non-root-admin-role-bindings": false,
  "vcs-provider-blob-storage": false,
  "flows-integration": false,
  "flows-aac-integration": false,
};
export const FEMarketingBanner = z.object({
  id: z.string(),
  expirationDate: z.string().optional(),
});

export type FEMarketingBanner = z.infer<typeof FEMarketingBanner>;

export const GlobalCallout = z.nullable(
  z.object({
    id: z.string().min(1),
    variant: z.enum(["info", "warning", "danger", "success", "promo"]),
    title: z.string(),
    description: z.string(),
    dismissible: z.boolean().default(true),
  })
);

export type GlobalCallout = z.infer<typeof GlobalCallout>;

export const PylonVerificationOverrides = z.object({
  email: z.string().optional(),
  account_external_id: z.string().optional(),
  contact_external_id: z.string().optional(),
});

export type PylonVerificationOverrides = z.infer<typeof PylonVerificationOverrides>;

type JsonTypes = {
  "fe-marketing-banners": FEMarketingBanner[];
  "fe-global-callout": GlobalCallout;
  "frontend-polling-seconds": {
    group?: Record<PollingIntervalGroups, number>;
    singleQuery?: Record<string, number>; // string is the Operation name
  };
  "pylon-verification-overrides": PylonVerificationOverrides;
};

type KebabToCamelCase<S extends string> = S extends `${infer P1}-${infer P2}${infer P3}`
  ? `${P1}${Uppercase<P2>}${KebabToCamelCase<P3>}`
  : S;

type ObjectKeysFromKebabToCamelCase<ObjectType> = {
  [K in keyof ObjectType as K extends string ? KebabToCamelCase<K> : K]: ObjectType[K];
};

type FlagsWithJsonValues = Omit<typeof flags, keyof JsonTypes> & JsonTypes;

export type Flags = ObjectKeysFromKebabToCamelCase<FlagsWithJsonValues>;
export type SefHostedFlags = ObjectKeysFromKebabToCamelCase<typeof selfHostedFlags>;
